import cn from 'classnames';
import type React from 'react';
import * as st from './styles.module.scss';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export const ListBody: React.FC<Props> = ({ children, className }) => {
  return (
    <main id="body" className={cn(st.body, className)}>
      {children}
    </main>
  );
};
